import * as React from "react";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../index";
import {ErrorBoundary} from "../../ErrorBoundary/ErrorBoundary";
import {DefaultErrorBoundaryFallback} from "../../ErrorBoundary/DefaultErrorBoundaryFallback";
import "./styles.scss";
import {ReadAndWriteProvider} from "../../providers/ReadAndWriteProvider";
import {VeboxUser} from "../../providers/VeboxUser";
import {MainContentPage} from "../pages/MainContentPage";
import {AccordionSectionProps} from "@vebox/etui-core";
import {Theme} from "@vebox/etui-themes";
import {ReadAndWriteDrawer} from "../components/Drawer";
import {SWRConfig, SWRConfiguration} from "swr";

interface ReadAndWriteProps {
    deviceGuid: string;
}

export const accordionStyle = (theme: Theme): AccordionSectionProps['styles'] => ({
    sectionContent: {
        height: "520px"
    },
    header: {
        title: {
            text: {
                fontWeight: "bold"
            },
        },
        root: {
            bg: theme.palette.grey[40],
        },
    },
});

const options: SWRConfiguration = {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    revalidateOnMount: true,
    refreshInterval: 1000 * 60 * 2, // 2 minutes
    onError: (error, key) => {
        console.error("SWR error", error, key);
        return error;
    }
}

export const ReadAndWrite: React.FC<ReadAndWriteProps> = ({deviceGuid}) => {
    const [open, setOpen] = React.useState(false);
    React.useEffect(() => {
        setTimeout(() => {
            setOpen(true);
        }, 500);
    }, []);
    return (
        <ThemeProvider theme={veboxDefaultTheme}>
            <ErrorBoundary fallback={<DefaultErrorBoundaryFallback/>}>
                <SWRConfig value={options}>
                    <div className={"rw-container"}>
                        <VeboxUser.Provider>
                            <ReadAndWriteProvider deviceGuid={deviceGuid}>
                                <div className={"flx-row fill-parent"}>
                                    <ReadAndWriteDrawer closable={true} open={open}/>
                                    <div className={"fill-parent main-content-section opacity-1"}>
                                        <MainContentPage/>
                                    </div>
                                </div>
                            </ReadAndWriteProvider>
                        </VeboxUser.Provider>
                    </div>
                </SWRConfig>
            </ErrorBoundary>
        </ThemeProvider>
    );
}








